export default __webpack_public_path__ + "static/media/trapezium-background.17c75094.png";